import '~/js/views/general/includes/scroll-below';
import VideoPopupPlay from '~/js/modules/video-popup';

// Variable Declaration
const $resortSelect = $('#js-resort-select');

// Initialization selectmenu
$resortSelect.selectmenu({
    appendTo: $resortSelect.parent()
});

//  link to option resort
const selectMenu = document.querySelector('#js-resort-select');
const selectModulMenu = document.querySelector('#js-resort-select-menu');
const selectModulButton = document.querySelector('#js-resort-select-button');

//  title resorts
selectModulButton.addEventListener('click', () => {
    for(let i = 0; i < selectMenu.children.length; i++) {
        if(!selectMenu.children[i].dataset.href) {
            selectModulMenu.children[i].classList.add('ui-selectmenu-optgroup');
            selectModulMenu.children[i].children[0].classList.remove('ui-menu-item-wrapper');
        }
        if(!selectMenu.children[i].dataset.href && i > 0) {
            selectModulMenu.children[i].classList.remove('ui-menu-item');
        }
    }
});

selectModulMenu.addEventListener('click', e => {
    for(let i = 0; i < selectMenu.children.length; i++) {
        if(e.target === selectModulMenu.children[i].children[0] && selectMenu.children[i].dataset.href) {
            const hrefAttr = selectMenu.children[i].dataset.href;

            window.location.href = `/${hrefAttr}/rooms-suites/?category=BUTLER`;
        }
    }
});

const videoPopup = new VideoPopupPlay('english-butler__btn');
